import { render, staticRenderFns } from "./MarketingSmsListItemActions.vue?vue&type=template&id=5fdbcf1e&scoped=true"
import script from "./MarketingSmsListItemActions.vue?vue&type=script&lang=js"
export * from "./MarketingSmsListItemActions.vue?vue&type=script&lang=js"
import style0 from "./MarketingSmsListItemActions.vue?vue&type=style&index=0&id=5fdbcf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdbcf1e",
  null
  
)

export default component.exports